import React from "react";
import { RegisterOptions, UseFormRegister } from "react-hook-form";
import { useTranslation, Trans } from "react-i18next";

import { Select } from "../input/Select";

type Props = {
  name: string;
  register: UseFormRegister<any>; // todo: どこかで定義したい
  options: RegisterOptions;
}

const PartsPrefecture: React.FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  
  return (
    <Select
      name={props.name}
      register={props.register}
      options={props.options}
      selectOptions={[
        { value: "北海道", label: t("Airport.北海道") },
        { value: "青森県", label: t("Airport.青森県") },
        { value: "岩手県", label: t("Airport.岩手県") },
        { value: "宮城県", label: t("Airport.宮城県") },
        { value: "秋田県", label: t("Airport.秋田県") },
        { value: "山形県", label: t("Airport.山形県") },
        { value: "福島県", label: t("Airport.福島県") },
        { value: "茨城県", label: t("Airport.茨城県") },
        { value: "栃木県", label: t("Airport.栃木県") },
        { value: "群馬県", label: t("Airport.群馬県") },
        { value: "埼玉県", label: t("Airport.埼玉県") },
        { value: "千葉県", label: t("Airport.千葉県") },
        { value: "東京都", label: t("Airport.東京都") },
        { value: "神奈川県", label: t("Airport.神奈川県") },
        { value: "新潟県", label: t("Airport.新潟県") },
        { value: "富山県", label: t("Airport.富山県") },
        { value: "石川県", label: t("Airport.石川県") },
        { value: "福井県", label: t("Airport.福井県") },
        { value: "山梨県", label: t("Airport.山梨県") },
        { value: "長野県", label: t("Airport.長野県") },
        { value: "岐阜県", label: t("Airport.岐阜県") },
        { value: "静岡県", label: t("Airport.静岡県") },
        { value: "愛知県", label: t("Airport.愛知県") },
        { value: "三重県", label: t("Airport.三重県") },
        { value: "滋賀県", label: t("Airport.滋賀県") },
        { value: "京都府", label: t("Airport.京都府") },
        { value: "大阪府", label: t("Airport.大阪府") },
        { value: "兵庫県", label: t("Airport.兵庫県") },
        { value: "奈良県", label: t("Airport.奈良県") },
        { value: "和歌山県", label: t("Airport.和歌山県") },
        { value: "鳥取県", label: t("Airport.鳥取県") },
        { value: "島根県", label: t("Airport.島根県") },
        { value: "岡山県", label: t("Airport.岡山県") },
        { value: "広島県", label: t("Airport.広島県") },
        { value: "山口県", label: t("Airport.山口県") },
        { value: "徳島県", label: t("Airport.徳島県") },
        { value: "香川県", label: t("Airport.香川県") },
        { value: "愛媛県", label: t("Airport.愛媛県") },
        { value: "高知県", label: t("Airport.高知県") },
        { value: "福岡県", label: t("Airport.福岡県") },
        { value: "佐賀県", label: t("Airport.佐賀県") },
        { value: "長崎県", label: t("Airport.長崎県") },
        { value: "熊本県", label: t("Airport.熊本県") },
        { value: "大分県", label: t("Airport.大分県") },
        { value: "宮崎県", label: t("Airport.宮崎県") },
        { value: "鹿児島県", label: t("Airport.鹿児島県") },
        { value: "沖縄県", label: t("Airport.沖縄県") },
      ]}
    />
  );
};

export default PartsPrefecture;